import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=2b0cf1a6&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=2b0cf1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cf1a6",
  null
  
)

export default component.exports